<div class="content-wrapper">
    <div class="content-body">
        <section id="dataToFilter">
            <ng-template #content>
                <div id="modal">
                    <div class="modal-header font-weight-bold">
                        <h4 class="modal-title font-weight-bold">
                            <i class="fas fa-flag-checkered cursor-pointer mr-2"></i>
                            <span>Follow Up - {{ selectedReferrer?.name }}</span>
                        </h4>
                        <i class="fas fa-times-circle pull-right text-danger cross-icon cursor-pointer"
                           (click)="this.modalService.dismissAll('')"></i>
                    </div>
                    <div class="modal-body">
                        <div class="row justify-content-center">
                            <form class="col-xl-8 col-lg-10 col-md-12 col-sm-12 form mt-2 shadow-none"
                                  novalidate [formGroup]="followUpForm">
                                <div class="form-group">
                                    <label for="status">Status</label>
                                    <select class="form-control" id="status" formControlName="status">
                                        <option value="">Select Status</option>
                                        <option [value]="option.value"
                                                *ngFor="let option of statusOptions">{{ option.label }}
                                        </option>
                                    </select>
                                    <small *ngIf="submitted && followUpForm.get('status').hasError('required')"
                                           class="text-danger">
                                        Field is required.
                                    </small>
                                    <small class="text-muted d-block mt-1">
                                        Setting status to "Admission Done" credits the referrer's reward once
                                        (points are configured in reward_rules, currently 1000).
                                    </small>
                                </div>
                                <div class="form-group">
                                    <label for="reason">Remark</label>
                                    <input id="reason"
                                           class="form-control"
                                           type="text"
                                           formControlName="reason"
                                           placeholder="Optional remark"
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success btn-raised" type="button"
                                [disabled]="submitting"
                                (click)="followUp()">
                            Submit
                        </button>
                    </div>
                </div>
            </ng-template>
            <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <h2 class="mt-5px">Referral Leads</h2>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
                    <button class="btn btn-primary pull-right color-white color-white users-btn mr-2"
                            (click)="showSearch = !showSearch">
                        <i aria-hidden="true" class="fa fa-search mr-8px"></i>&nbsp;Search
                    </button>
                </div>
            </div>
            <div class="row search-card mt-3" *ngIf="showSearch">
                <div class="col-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                        <div class="row">
                            <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="email" placeholder="Email">
                                </fieldset>
                            </div>
                            <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="contact"
                                           placeholder="Mobile">
                                </fieldset>
                            </div>
                            <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12 text-center">
                                <button class="btn btn-primary btn-block btn-raised color-white mr-2 users-btn"
                                        (click)="search()"
                                        [disabled]="submitting">
                                    <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Search
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="row d-none d-md-block mt-3">
                <div class="col-12">
                    <div class="card">
                        <div class="container-fluid">
                            <div class="row overflow-x-scroll overflow-table">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <table class="table table-list text-center">
                                        <thead>
                                        <tr>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">S.No</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Full
                                                Name</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Mobile</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Email</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">User
                                                Type</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Referral
                                                Code</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Status</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Referrals</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Converted</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Available
                                                Points</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Registered
                                                On</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Follow
                                                Up</h6>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody *ngIf="dataToFilter && dataToFilter.length > 0 && (!filteredData || filteredData.length === 0); else filteredTable">
                                        <tr *ngFor="let admin of dataToFilter; let i = index">
                                            <td class="text-center">
                                                <h6 class="mt-1">{{ (pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1 }}
                                                    .</h6>
                                            </td>
                                            <td class="text-center"><h6 class="mt-1">{{ admin?.name }}</h6></td>
                                            <td class="text-center"><h6 class="mt-1">{{ admin?.mobile }}</h6></td>
                                            <td class="text-center"><h6 class="mt-1">{{ admin?.email }}</h6></td>
                                            <td class="text-center"><h6 class="mt-1">{{ admin?.user_type }}</h6></td>
                                            <td class="text-center"><h6 class="mt-1">{{ admin?.referral_code }}</h6>
                                            </td>
                                            <td class="text-center">
                                                <span class="badge"
                                                      [ngClass]="admin?.status === 'ACTIVE' ? 'badge-success' : 'badge-secondary'">
                                                    {{ admin?.status }}
                                                </span>
                                            </td>
                                            <td class="text-center"><h6 class="mt-1">{{ admin?.referrals_count }}</h6>
                                            </td>
                                            <td class="text-center"><h6 class="mt-1">{{ admin?.converted_count }}</h6>
                                            </td>
                                            <td class="text-center"><h6 class="mt-1">{{ admin?.available_points }}</h6>
                                            </td>
                                            <td class="text-center"><h6
                                                    class="mt-1">{{ admin?.registered_at | date:'yyyy-MM-dd HH:mm:ss' }}</h6>
                                            </td>
                                            <td class="text-center max-width-250px">
                                                <ng-container *ngIf="admin?.inbound_referral_id; else notReferred">
                                                    <span class="badge"
                                                          [ngClass]="admin?.inbound_referral_status === 'CONVERTED' ? 'badge-success' : 'badge-primary'">
                                                        {{ admin?.inbound_referral_status === 'CONVERTED' ? 'Admission Done' : admin?.inbound_referral_status }}
                                                    </span>
                                                    <br/>
                                                    <span class="text-info cursor-pointer"
                                                          (click)="changeFollowUp(content, admin)">
                                                        Update
                                                    </span>
                                                </ng-container>
                                                <ng-template #notReferred>--</ng-template>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <ng-template #filteredTable>
                                            <tbody *ngIf="filteredData && filteredData.length > 0; else noDataToShowWeb">
                                            <tr *ngFor="let admin of filteredData; let i = index">
                                                <td class="text-center">
                                                    <h6 class="mt-1">{{ (pagination.page - 1) * pagination.perpage + i + 1 }}
                                                        .</h6>
                                                </td>
                                                <td class="text-center"><h6 class="mt-1">{{ admin?.name }}</h6></td>
                                                <td class="text-center"><h6 class="mt-1">{{ admin?.mobile }}</h6></td>
                                                <td class="text-center"><h6 class="mt-1">{{ admin?.email }}</h6></td>
                                                <td class="text-center"><h6 class="mt-1">{{ admin?.user_type }}</h6>
                                                </td>
                                                <td class="text-center"><h6
                                                        class="mt-1">{{ admin?.referral_code }}</h6></td>
                                                <td class="text-center">
                                                    <span class="badge"
                                                          [ngClass]="admin?.status === 'ACTIVE' ? 'badge-success' : 'badge-secondary'">
                                                        {{ admin?.status }}
                                                    </span>
                                                </td>
                                                <td class="text-center"><h6
                                                        class="mt-1">{{ admin?.referrals_count }}</h6></td>
                                                <td class="text-center"><h6
                                                        class="mt-1">{{ admin?.converted_count }}</h6></td>
                                                <td class="text-center"><h6
                                                        class="mt-1">{{ admin?.available_points }}</h6></td>
                                                <td class="text-center"><h6
                                                        class="mt-1">{{ admin?.registered_at | date:'yyyy-MM-dd HH:mm:ss' }}</h6>
                                                </td>
                                                <td class="text-center max-width-250px">
                                                    <ng-container *ngIf="admin?.inbound_referral_id; else notReferredFiltered">
                                                        <span class="badge"
                                                              [ngClass]="admin?.inbound_referral_status === 'CONVERTED' ? 'badge-success' : 'badge-primary'">
                                                            {{ admin?.inbound_referral_status === 'CONVERTED' ? 'Admission Done' : admin?.inbound_referral_status }}
                                                        </span>
                                                        <br/>
                                                        <span class="text-info cursor-pointer"
                                                              (click)="changeFollowUp(content, admin)">
                                                            Update
                                                        </span>
                                                    </ng-container>
                                                    <ng-template #notReferredFiltered>--</ng-template>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </ng-template>
                                        <ng-template #noDataToShowWeb>
                                            <tbody>
                                            <tr>
                                                <td colspan="12" class="text-center"><h6>No data to show.</h6></td>
                                            </tr>
                                            </tbody>
                                        </ng-template>

                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Displaying Data on Small Screens -->
            <div class="row mt-3 d-block d-md-none"
                 *ngIf="dataToFilter && dataToFilter.length > 0; else noDataToShowMobile">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" *ngFor="let admin of dataToFilter; let i = index">
                    <div class="card">
                        <div class="card-header bottom-shadow-light pb-18px">
                            <div class="row width-100-per">
                                <div class="col-6">
                                    <h4 class="card-title text-uppercase card-ellipsis">
                                        {{ (pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1 }}
                                        .
                                        {{ admin?.name }}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noDataToShowMobile>
                <div class="row mt-3 d-block d-md-none">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="card text-center">
                            <h5 class="p-5">No data to show</h5>
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="row pagination-table">
                <ngb-pagination class="pagination-primary" [collectionSize]="pagination.total"
                                [(page)]="pagination.page" [boundaryLinks]="true"
                                [pageSize]="pagination.perpage" [maxSize]="5"
                                (pageChange)="onPageChange($event)">
                    <ng-template ngbPaginationPrevious>
                        <span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder'"></span>
                    </ng-template>
                    <ng-template ngbPaginationNext>
                        <span [data-feather]="'chevron-right'" [size]="18" [class]="'font-weight-bolder'"></span>
                    </ng-template>
                </ngb-pagination>
            </div>
        </section>
    </div>
</div>
